<div *ngIf="show && parentFormGroup">
    <form [formGroup]="formGroup">
        <div class="timer-select-container">
            <select-formulario 
                [selectConfiguration]="horaSelectConfiguration" 
                name="horas"
                label="Horas"
                formControlName="horas"
                [(value)]="horasValue" 
                [parentFormGroup]="formGroup"
                (valueChange)="changeHora($event)"
            ></select-formulario>

    
            <select-formulario 
                [selectConfiguration]="minutosSelectConfiguration" 
                name="minutos"
                label="Minutos"
                formControlName="minutos"
                [(value)]="minutosValue" 
                [parentFormGroup]="formGroup"
                (valueChange)="changeHora($event)"
            ></select-formulario>
        </div>
    </form>
</div>